export default __webpack_public_path__ + "static/media/logo.6b8945c7.svg";